/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-spinner.html";
import { events } from "@nuskin/ns-util";

import spinner from "../assets/spinner.gif";

// import '@nuskin/ns-style-elements';

export class NsSpinner extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-spinner";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      opened: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      src: {
        type: String,
        value: spinner
      }
    };
  }

  ready() {
    super.ready();
    events.subscribe("closeSpinner", () => {
      this.hide();
    });
    events.subscribe("openSpinner", () => {
      this.show();
    });
    events.subscribe("toggleSpinner", () => {
      this.toggle();
    });
  }

  show() {
    this.opened = true;
  }

  hide() {
    this.opened = false;
  }

  toggle() {
    this.opened ? this.hide() : this.show();
  }
}
customElements.define(NsSpinner.is, NsSpinner);
